import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { QuestionMarkCircleOutlineIcon } from '@compono/ui-icons';
import { FieldFooter } from './FieldFooter/index.js';
import { Text } from '../Text/Text.js';
import { Label } from '../Label/index.js';
import { ToggleTip } from '../ToggleTip/ToggleTip.js';
import '@emotion/react/jsx-runtime';
import '@emotion/react';
import 'lodash.get';
import '@compono/ui-theme';
import 'deepmerge';
import '@emotion/is-prop-valid';
import 'react';
import '@reach/utils';
import '../ToggleTip/components/ToggleTipProvider.js';
import '../ToggleTip/components/ToggleTipButton.js';
import '../Box/index.js';
import '../ToggleTip/components/ToggleTipIconButton.js';
import '../ToggleTip/components/ToggleTipPopover.js';
import '../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import { Inline } from '../Inline/Inline.js';
import { Stack } from '../Stack/Stack.js';

// map sizes to theme sizes scale
var gridRowGapMap = { sm: 1, md: 3, lg: 4 };
// map subCopy text size to size
var subCopyTextSizeMap = {
    xs: "xxs",
    sm: "xs",
    md: "sm",
    lg: "md",
};
var FormField = function (_a) {
    var label = _a.label, error = _a.error, isGroup = _a.isGroup, hint = _a.hint, fieldId = _a.fieldId, info = _a.info, children = _a.children, subCopy = _a.subCopy, sx = _a.sx, _b = _a.optional, optional = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? "md" : _c, props = __rest(_a, ["label", "error", "isGroup", "hint", "fieldId", "info", "children", "subCopy", "sx", "optional", "size"]);
    var footerProps = {
        error: error,
        hint: hint,
        fieldId: fieldId,
        size: size,
    };
    var getLabelledByIds = function () {
        return ["".concat(fieldId, "-label"), subCopy ? "".concat(fieldId, "-label-subCopy") : ""].join(" ");
    };
    var hasErrorHint = !!(error === null || error === void 0 ? void 0 : error.length) || !!(hint === null || hint === void 0 ? void 0 : hint.length);
    return (jsxs(Stack, __assign({}, (isGroup && {
        role: "group",
        "aria-labelledby": getLabelledByIds(),
        required: !optional,
    }), { gap: gridRowGapMap[size], sx: __assign({}, sx) }, props, { children: [label && (jsxs(Stack, { children: [jsxs(Inline, { children: [jsx(Label, __assign({ id: "".concat(fieldId, "-label"), htmlFor: isGroup ? undefined : fieldId, size: size }, { children: jsxs(Inline, __assign({ gap: "2" }, { children: [label, optional && jsx(Text, __assign({ tone: "subtle" }, { children: "(Optional)" }))] })) })), Boolean(info) && (jsx(ToggleTip, __assign({ icon: jsx(QuestionMarkCircleOutlineIcon, {}), buttonSx: { color: "black.60" } }, { children: info })))] }), Boolean(subCopy) && (jsx(Text, __assign({ id: "".concat(fieldId, "-label-subCopy"), size: subCopyTextSizeMap[size], tone: "subtle" }, { children: subCopy })))] })), children, hasErrorHint && jsx(FieldFooter, __assign({}, footerProps))] })));
};

export { FormField };
//# sourceMappingURL=FormField.js.map
